var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const BASE_URL = 'https://arenacloud.cdn.arkadiumhosted.com/jarvis-api-prod';
const DEFAULT_CONFIG = 'default';
const fetchResponseRaw = (host) => fetch(`${BASE_URL}/v3/domains/name/${host}`);
export function fetchResponse(host) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchResponseRaw(host);
        return (response.ok && response.status === 200)
            ? (yield response.json())
            : (yield fetchResponseRaw(DEFAULT_CONFIG).then((r) => r.json()));
    });
}
